import script from "./OrderManage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderManage.vue?vue&type=script&setup=true&lang=js"

import "./OrderManage.vue?vue&type=style&index=0&id=6b4230f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4230f8"]])

export default __exports__